document.addEventListener('DOMContentLoaded', (event) => {
    var x, i, j, l, ll, selElmnt, a, b, c;
    x = document.getElementsByClassName("celebrate-term-dropdown");
    l = x.length;
    for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        a = x[i].getElementsByClassName("select-selected")[0];
        b = x[i].getElementsByClassName("select-items")[0];
        a.innerHTML = "";
        b.innerHTML = "";
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        for (j = 1; j < ll; j++) {
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.dataset.value = selElmnt.options[j].value;
            var dataLevel = selElmnt.options[j].getAttribute('data-level');
            c.classList.add("level-" + dataLevel);

            c.addEventListener("click", function (e) {
                var y, i, k, s, h, sl, yl;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                sl = s.length;
                h = this.parentNode.previousSibling;
                for (i = 0; i < sl; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName("same-as-selected");
                        yl = y.length;
                        for (k = 0; k < yl; k++) {
                            y[k].removeAttribute("class");
                        }
                        this.setAttribute("class", "same-as-selected");
                        break;
                    }
                }
                h.click();

                s.value = this.dataset.value;
                var event = new Event('change');
                s.dispatchEvent(event);
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function (e) {
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
        });

        selElmnt.addEventListener('change', function() {
            var selectedOption = this.options[this.selectedIndex];
            a.innerHTML = selectedOption.text;
        });
    }
});

function closeAllSelect(elmnt) {
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
            arrNo.push(i)
        } else {
            y[i].classList.remove("select-arrow-active");
        }
    }
    for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
        }
    }
}

document.addEventListener("click", closeAllSelect);